import React from 'react';
import { HashLink } from 'react-router-hash-link';
import NavBar from './Navbar/NavBar';
import heroImg from '../images/mcn-ai-hero.webp';

const Hero = () => (
    <div className="hero" id="hero">
        <NavBar />
        <section aria-labelledby="hero-title" className="mx-auto max-w-screen-2xl px-5 pt-32 pb-12 sm:px-8 sm:pt-40 lg:px-12 lg:pb-20">
            <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-12">
                <div className="text-center lg:text-left">
                    <h1 id="hero-title" className="text-3xl sm:text-4xl xl:text-5xl leading-tight font-bold text-blue-900">
                        Audio, Video &amp; Multimodal AI for Real-World Applications
                    </h1>
                    <p className="mt-6 text-lg sm:text-xl leading-relaxed text-gray-600">
                        We build products and custom AI solutions that create and translate media, understand images, and connect voice conversations to business workflows. Our applications span content creation, healthcare operations, medical imaging, and skills assessment.
                    </p>
                    <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap justify-center lg:justify-start">
                        <HashLink smooth to="/#services" className="inline-flex items-center justify-center rounded-xl bg-blue-900 px-6 py-3 text-base font-semibold text-white shadow-md hover:bg-blue-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-900">
                            Explore our solutions <span className="ml-2" aria-hidden="true">→</span>
                        </HashLink>
                        <HashLink to="/contact#contact" className="inline-flex items-center justify-center rounded-xl border border-blue-900 bg-white px-6 py-3 text-base font-semibold text-blue-900 hover:bg-blue-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-900">
                            Discuss your project
                        </HashLink>
                    </div>
                </div>
                <img src={heroImg} alt="Illustration of an audio and video workspace connected to healthcare scheduling, medical imaging, and skills assessment" width="1200" height="1200" fetchpriority="high" className="mx-auto block w-full max-w-xl rounded-2xl object-contain" />
            </div>
        </section>
    </div>
);

export default Hero;
